// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.countries.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/countries/country/country.tpl.html',
            controller: 'CountryController as vm'
        }},
        resolve: {
            country: function() { return {}; },
            isNewCountry: function() {return true;},
            vats: vatsResolver
        }
    });
    $stateProvider.state('base.countries.country', {
        url:'/{countryId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/countries/country/country.tpl.html',
            controller: 'CountryController as vm'
        }},
        resolve: {
            country: countryResolver,
            vats: vatsResolver,
            isNewCountry: function() {return false;}
        }
    });
}

// @ngInject
function countryResolver($stateParams, CountriesApiService) {
    return CountriesApiService.getCountryById($stateParams.countryId);
}

// @ngInject
function vatsResolver(VatsApiService) {
    return VatsApiService.getVats();
}

// @ngInject
function CountryController($state, country, loadSpinnerService, CountriesApiService, ToasterService, confirmationDialogService, $translate, isNewCountry, vats) {
    var vm = this;

    var countryCopy = {};

    //Properties
    vm.isNewCountry = isNewCountry;
    vm.isEditing = vm.isNewCountry;
    vm.country = country;
    vm.vats = vats;
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactCountryView') !== 'false';
    vm.reactCountryId = isNewCountry ? null : (country && country.id != null ? country.id : null);

    //Methods
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveCountry = saveCountry;
    vm.deleteCountry = deleteCountry;
    vm.isCountryCodeValid = isCountryCodeValid;
    vm.isAllInformationValid = isAllInformationValid;
    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        prepareData();
        if (vm.isNewCountry) {
            vm.country = {};
        }
        appendVats(vm.country, vm.vats);
    }

    function appendVats(obj, vats) {
        if (!obj.vats) {
            obj.vats = [];
        }

        _.forEach(vats, function(vat) {
            var countryVats = _.filter(obj.vats, { vat: { id: vat.id}});
            var countryVat;
            if (countryVats.length === 0) {
                countryVat = { vat: vat,  vatRate: vat.vatRate};
                obj.vats.push(countryVat);
            }
        });
    }

    function enableEditing() {
        countryCopy = angular.copy(vm.country);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.country = countryCopy;
        vm.isEditing = false;
    }

    function saveCountry() {
        if (vm.isNewCountry) {
            saveNewCountry();
        } else {
            updateCountry();
        }
    }

    function saveNewCountry() {
        loadSpinnerService.start('mainSpinner');
        CountriesApiService.createCountry(vm.country).then(function(response) {
            vm.country = response;
            prepareData();
            vm.isNewCountry = false;
            vm.isEditing = false;
            $state.go('base.countries.country', {countryId: vm.country.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateCountry() {
        loadSpinnerService.start('mainSpinner');

        CountriesApiService.updateCountry(vm.country).then(function(response) {
            vm.country = response;
            prepareData();
            vm.isNewCountry = false;
            vm.isEditing = false;
            $state.go('base.countries.country', {countryId: vm.country.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteCountry() {
        confirmationDialogService
            .showDialog($translate.instant('country.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    CountriesApiService.deleteCountry(vm.country.id).then(function(response) {
                        vm.country = response;
                        prepareData();
                        vm.isNewCountry = false;
                        vm.isEditing = false;
                        $state.go('base.countries');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(country) {
        country.showEditForm = !country.showEditForm;
    }

    function prepareData() {
        if (vm.country === undefined) {
            return;
        }

        vm.countryCopy = angular.copy(vm.country);
    }

    function isAllInformationValid() {
        return isCountryCodeValid();
    }

    function isCountryCodeValid() {
        //if (vm.country && vm.country.code && vm.country.code.length > 3) { return false; }

        return true;
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('countries.country', [])
    .config(stateConfig)
    .controller('CountryController', CountryController);
